import type { MouseEvent } from 'react';
import type { MenuProps } from '@mui/material';
import { Menu, MenuItem } from '@mui/material';

export interface ContextMenuParams {
  rowId: string;
  field: string;
}

export interface ContextMenuItem {
  label: string;
  onClick: () => void;
  destructive?: boolean;
}

export type ContextMenuProps = Pick<
  MenuProps,
  'open' | 'anchorReference' | 'anchorEl' | 'anchorPosition' | 'disablePortal'
> & {
  items: ContextMenuItem[];
  onClose?: () => void;
  autoFocusItem?: boolean;
};

export default function ContextMenu({
  open,
  onClose,
  anchorReference,
  anchorEl,
  anchorPosition,
  disablePortal,
  items,
  autoFocusItem = true,
}: ContextMenuProps) {
  const handleItemClick = (item: ContextMenuItem) => {
    item.onClick();
    onClose?.();
  };

  return (
    <Menu
      open={open}
      onClose={() => onClose?.()}
      anchorReference={anchorReference}
      anchorEl={anchorEl}
      anchorPosition={anchorPosition}
      disablePortal={disablePortal}
      autoFocus={autoFocusItem}
      slotProps={{
        root: { onClick: (e: MouseEvent) => e.stopPropagation() },
        list: { autoFocusItem },
      }}
    >
      {items.map((item, index) => (
        <MenuItem
          key={`${item.label}-${index}`}
          onClick={() => handleItemClick(item)}
          sx={item.destructive ? { color: 'error.main' } : undefined}
        >
          {item.label}
        </MenuItem>
      ))}
    </Menu>
  );
}
